// Phase H.10 — TipTap inline custom node for merge tags.
//
// Renders in the editor as a styled rounded chip showing e.g.
// `{{company.ein_tax_id}}`; on save, a post-process pass strips the wrapping
// <span data-merge-tag="..."> back to plain `{{tag.path}}` text so the
// existing server-side PDF renderer (`_substitute_html` in server.py) keeps
// working unchanged.

import { Node, mergeAttributes } from "@tiptap/core";

const SIGNATURE_TAG_PREFIXES = ["signature_"];

function isSignatureTag(path) {
    if (!path) return false;
    return SIGNATURE_TAG_PREFIXES.some((p) => path.startsWith(p));
}

export const MergeTagNode = Node.create({
    name: "mergeTag",

    group: "inline",
    inline: true,
    atom: true,
    selectable: true,

    addAttributes() {
        return {
            path: {
                default: "",
                parseHTML: (el) => el.getAttribute("data-merge-tag") || "",
                renderHTML: (attrs) => ({ "data-merge-tag": attrs.path }),
            },
        };
    },

    parseHTML() {
        return [{ tag: "span[data-merge-tag]" }];
    },

    renderHTML({ node, HTMLAttributes }) {
        const path = node.attrs.path || "";
        const sig = isSignatureTag(path);
        const cls = sig
            ? "tt-merge-tag tt-merge-tag--signature"
            : "tt-merge-tag";
        return [
            "span",
            mergeAttributes(HTMLAttributes, {
                "data-merge-tag": path,
                class: cls,
                spellcheck: "false",
            }),
            `{{${path}}}`,
        ];
    },

    renderText({ node }) {
        return `{{${node.attrs.path || ""}}}`;
    },

    addCommands() {
        return {
            insertMergeTag:
                (path) =>
                ({ commands }) =>
                    commands.insertContent({
                        type: this.name,
                        attrs: { path },
                    }),
        };
    },
});

export default MergeTagNode;
